export enum StatusEnums {
  REGISTRO_PLATAFORMA = 'REGISTRO PLATAFORA',
  REGISTRO_WEB = 'REGISTRO_WEB',
  REGISTRO_TALLER = 'REGISTRO DESDE TALLER',
  RECIBIDA = 'RECIBIDA',
  RECIBIDA_TECNICO = 'RECIBIDA POR EL TECNICO',
  EN_TALLER = 'EN TALLER',
  DEVUELTA = 'DEVUELTA',
  CANCELADA = 'CANCELADA',
  CERRADA = 'CERRADA',
  PROGRAMADA = 'PROGRAMADA',
}
